import {
  Button,
  Checkbox,
  Grid,
  IconButton,
  ListItemText,
  Tooltip
} from '@mui/material';
import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DateRange from 'src/components/common/DateRange';
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';
import goodalipi from 'src/plugins/goodalipi';
class SearchRecords extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.filter;
    this.globalHR = goodalipi.get('globalHR');
  }
  handleChange(type, value) {
    let {
      dateRange,
      campLocation,
      providerName,
      campType,
      benf,
      payment,
      entityRequested
    } = this.setState;
    switch (type) {
      case 'dateRange':
        dateRange = value;
        break;
      case 'campLocation':
        campLocation = value;
        break;
      case 'campType':
        campType = value;
        break;
      case 'providerName':
        providerName = value;
        break;
      case 'benf':
        benf = value;
        break;
      case 'payment':
        payment = value;
        break;
      case 'entityRequested':
        entityRequested = value;
    }
    let obj = {};
    if (dateRange) {
      obj.dateRange = dateRange;
    }
    if (campLocation) {
      obj.campLocation = campLocation;
    }
    if (providerName) {
      obj.providerName = providerName;
    }
    if (campType) {
      obj.campType = campType;
    }
    if (benf) {
      obj.benf = benf;
    }
    if (payment) {
      obj.payment = payment;
    }
    if (entityRequested) {
      obj.entityRequested = entityRequested;
    }
    this.setState(obj, () => {
      this.props.setFilters(this.state);
    });
  }
  render() {
    return (
      <Grid direction="row" container>
        <Grid item xs={12} sm={4} md = {4} sx = {{pr : 2}}>
            <DateRange boxsize='small' onDateChange={(value) => { this.handleChange('dateRange', value) }} />
        </Grid>

        {this.globalHR && 
          <Grid item container xs={12} md={3} sm={6}>
            <FormControl size="small" fullWidth variant="outlined">
              <InputLabel>EntityId</InputLabel>
              <Select
                value={this.state.entityRequested}
                onChange={(ev) => {
                  this.handleChange('entityRequested', ev.target.value);
                }}
                label="EntityId"
              >
                {this.props.filterOptions.entityRequested.map((val, idx) => (
                  <MenuItem sx={{ py: 0 }} value={val.val} key={idx}>
                    <ListItemText primary={val.key} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        }
         
         

        <Grid item container justifyContent="space-around" xs={2} md={2} sm={3}>
          <Tooltip title="Refresh">
            <IconButton
              // sx={{
              //   bgcolor: 'white',
              //   boxShadow: '0 0 3px rgba(0,0,0,0.31)',
              //   width: '30px',
              // }}
              color="primary"
              size="small"
              onClick={this.props.onRefresh}
            >
              <Refresh color="primary" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Reset">
            <IconButton
              // sx={{
              //   bgcolor: 'white',
              //   boxShadow: '0 0 4px rgba(0,0,0,0.31)'
              // }}
              color="primary"
              size="small"
              onClick={() => window.location.reload()}
            >
              <ClearIcon color="primary" />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    );
  }
}

SearchRecords.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired
};

export default SearchRecords;